"use strict";

const read = function () {
  return Cookies.get("hint.session-token.provider") || null;
};

const SessionPort = {
  read: read,
  add: function (app) {
    window.addEventListener("session:updated", function () {
      app.ports.onSessionUpdatedPort.send(read());
    });

    if (app.ports.onSessionTokenCreatedPort) {
      window.addEventListener("session-token:created", function (event) {
        app.ports.onSessionTokenCreatedPort.send({
          accessToken: event.detail.accessToken || read(),
          redirectToURI: event.detail.redirectToURI,
        });
      });
    }

    if (app.ports.onSessionLoggedOutPort) {
      window.addEventListener("session:loggedout", function () {
        app.ports.onSessionLoggedOutPort.send(null);
      });
    }

    if (app.ports.logoutPort) {
      app.ports.logoutPort.subscribe(() => {
        const FronteggPort = require("./frontegg.js");
        FronteggPort.logout();
      });
    }

    if (app.ports.onLogoutWarningPort) {
      window.addEventListener("session:warning", function () {
        app.ports.onLogoutWarningPort.send(null);
      });
    }
    if (app.ports.sessionCreatedPort) {
      app.ports.sessionCreatedPort.subscribe(() => {
        window.dispatchEvent(new Event("session:updated"));
      });
    }
  },
};

module.exports = SessionPort;
